'use client';

import classNames from 'classnames';
import { memo, useEffect, useRef, useState } from 'react';

interface IProps extends React.HTMLAttributes<HTMLDivElement> {
  classHasChild?: string;
  classNoChild?: string;
}

// 用于有 children 就显示，否则就隐藏的容器
function AutoHide(props: IProps): JSX.Element {
  const {
    classHasChild = '',
    classNoChild = '!w-0 !h-0 !hidden',
    className,
    ...otherProps
  } = props;
  const divRef = useRef<HTMLDivElement>(null);
  const [show, setShow] = useState<boolean>(false);

  useEffect(() => {
    const divObserver = new MutationObserver(() => {
      if (divRef.current) {
        setShow(!!divRef.current.childElementCount);
      }
    });

    if (divRef.current) {
      setShow(!!divRef.current.childElementCount);
      divObserver.observe(divRef.current, { childList: true });
    }

    return () => {
      divObserver.disconnect();
    };
  }, []);

  useEffect(() => {
    if (divRef.current) {
      setShow(!!divRef.current.childElementCount);
    }
  }, []);

  return (
    <div
      ref={divRef}
      className={classNames(className, show ? classHasChild : classNoChild)}
      {...otherProps}
    />
  );
}

export default memo(AutoHide);
